import React from 'react';
import { Bubble } from '@lt/components';
import type {
  Placement,
  BubbleEventType,
  BubbleWidth,
} from '@lt/components/components/Bubble';

import { useTranslation } from '@lt/localization';

interface IBubbleIncludedServices {
  children: JSX.Element[] | JSX.Element;
  placement?: Placement;
  eventType?: BubbleEventType;
  width?: BubbleWidth;
  noWrap?: boolean;
}

const BubbleIncludedServices: React.FC<IBubbleIncludedServices> = ({
  children,
  placement = 'bottom',
  eventType = 'hover',
  width = 260,
  noWrap = false,
}) => {
  const { t } = useTranslation();
  return (
    <Bubble
      eventType={eventType}
      placement={placement}
      closeable={false}
      width={width}
      noWrap={noWrap}
      inline
      text={t('hotel.IncludedServices.services')}
    >
      {children}
    </Bubble>
  );
};

export default BubbleIncludedServices;
